import { render, staticRenderFns } from "./BuyOrderText.vue?vue&type=template&id=9cb95968&scoped=true"
import script from "./BuyOrderText.vue?vue&type=script&lang=js"
export * from "./BuyOrderText.vue?vue&type=script&lang=js"
import style0 from "./BuyOrderText.vue?vue&type=style&index=0&id=9cb95968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb95968",
  null
  
)

export default component.exports